import React from 'react';
    import { motion } from 'framer-motion';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiArrowRight } = FiIcons;

    const TransformationSection = () => {
      const transformations = [
        {
          from: 'Burnout & Overwhelm',
          to: 'Sustainable Systems',
          description: 'Stop working 80-hour weeks just to stay afloat. Build systems that work while you rest.',
        },
        {
          from: 'Scattered Chaos',
          to: 'Crystal Clarity',
          description: 'No more jumping between 47 different tools. One clear path, one focused direction.',
        },
        {
          from: 'Endless Hustle',
          to: 'Sustainable Income',
          description: 'Transform your scattered efforts into predictable revenue streams that grow while you sleep.',
        },
      ];

      return (
        <section id="transformation" className="py-20 relative">
          <div className="container mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-6xl font-orbitron font-bold mb-6">
                Your <span className="clarity-gradient">Transformation</span>
              </h2>
              <p className="text-xl text-gray-300 font-poppins max-w-3xl mx-auto">
                See the journey from where you are now to where you want to be. This isn't just about business—it's about reclaiming your life.
              </p>
            </motion.div>
            <div className="space-y-12">
              {transformations.map((transformation, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  className="flex flex-col lg:flex-row items-center justify-between bg-gradient-to-r from-gray-800/30 to-gray-900/30 p-8 rounded-3xl border border-gray-700/30 backdrop-blur-sm"
                >
                  <div className="flex-1 text-center lg:text-left mb-6 lg:mb-0">
                    <h3 className="text-2xl font-poppins font-light text-red-400 mb-2">
                      From: {transformation.from}
                    </h3>
                    <p className="text-gray-400 font-poppins">{transformation.description}</p>
                  </div>
                  <div className="mx-8 mb-6 lg:mb-0">
                    <motion.div
                      animate={{ x: [0, 10, 0] }}
                      transition={{ duration: 2, repeat: Infinity }}
                      className="w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center"
                    >
                      <SafeIcon icon={FiArrowRight} className="text-white text-xl" />
                    </motion.div>
                  </div>
                  <div className="flex-1 text-center lg:text-right">
                    <h3 className="text-2xl font-poppins font-semibold text-green-400 mb-2">
                      To: {transformation.to}
                    </h3>
                    <p className="text-gray-300 font-poppins">
                      The life and business you actually want to live.
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              className="text-center mt-16"
            >
              <motion.a
                href="https://connect.withjahx.com"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-purple-600 to-blue-600 px-8 py-4 rounded-full font-poppins font-semibold text-lg glow-button inline-block"
              >
                Start Your Transformation
              </motion.a>
            </motion.div>
          </div>
        </section>
      );
    };

    export default TransformationSection;